"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.filter.js");
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _filterBar = _interopRequireDefault(require("@gravity/filter-bar"));
var _filter = require("@nucleo/filter");
var _jsxFileName = "/codebuild/output/src975848493/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/ProductList/lib/TabFilterBar.js";
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_1jpptz9cup() {
  var path = "/codebuild/output/src975848493/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/ProductList/lib/TabFilterBar.js";
  var hash = "e51146946f70cd6250cc56b46e570538ca5fb624";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src975848493/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/ProductList/lib/TabFilterBar.js",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 13,
          column: 17
        }
      },
      "1": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 16,
          column: 6
        }
      },
      "2": {
        start: {
          line: 19,
          column: 15
        },
        end: {
          line: 20,
          column: 84
        }
      },
      "3": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 84
        }
      },
      "4": {
        start: {
          line: 20,
          column: 31
        },
        end: {
          line: 20,
          column: 73
        }
      },
      "5": {
        start: {
          line: 22,
          column: 24
        },
        end: {
          line: 33,
          column: 3
        }
      },
      "6": {
        start: {
          line: 22,
          column: 35
        },
        end: {
          line: 33,
          column: 3
        }
      },
      "7": {
        start: {
          line: 23,
          column: 24
        },
        end: {
          line: 28,
          column: 5
        }
      },
      "8": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 32,
          column: 7
        }
      },
      "9": {
        start: {
          line: 31,
          column: 6
        },
        end: {
          line: 31,
          column: 46
        }
      },
      "10": {
        start: {
          line: 35,
          column: 23
        },
        end: {
          line: 46,
          column: 3
        }
      },
      "11": {
        start: {
          line: 35,
          column: 34
        },
        end: {
          line: 46,
          column: 3
        }
      },
      "12": {
        start: {
          line: 37,
          column: 24
        },
        end: {
          line: 42,
          column: 5
        }
      },
      "13": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 45,
          column: 7
        }
      },
      "14": {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 44,
          column: 40
        }
      },
      "15": {
        start: {
          line: 56,
          column: 8
        },
        end: {
          line: 56,
          column: 18
        }
      },
      "16": {
        start: {
          line: 58,
          column: 28
        },
        end: {
          line: 58,
          column: 34
        }
      },
      "17": {
        start: {
          line: 59,
          column: 27
        },
        end: {
          line: 59,
          column: 54
        }
      },
      "18": {
        start: {
          line: 61,
          column: 23
        },
        end: {
          line: 65,
          column: 5
        }
      },
      "19": {
        start: {
          line: 66,
          column: 38
        },
        end: {
          line: 69,
          column: 5
        }
      },
      "20": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 82,
          column: 6
        }
      },
      "21": {
        start: {
          line: 86,
          column: 0
        },
        end: {
          line: 103,
          column: 2
        }
      },
      "22": {
        start: {
          line: 104,
          column: 0
        },
        end: {
          line: 110,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        },
        loc: {
          start: {
            line: 12,
            column: 21
          },
          end: {
            line: 17,
            column: 3
          }
        },
        line: 12
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 19,
            column: 15
          },
          end: {
            line: 19,
            column: 16
          }
        },
        loc: {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 20,
            column: 84
          }
        },
        line: 20
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 20,
            column: 18
          },
          end: {
            line: 20,
            column: 19
          }
        },
        loc: {
          start: {
            line: 20,
            column: 31
          },
          end: {
            line: 20,
            column: 73
          }
        },
        line: 20
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 22,
            column: 24
          },
          end: {
            line: 22,
            column: 25
          }
        },
        loc: {
          start: {
            line: 22,
            column: 35
          },
          end: {
            line: 33,
            column: 3
          }
        },
        line: 22
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 22,
            column: 35
          },
          end: {
            line: 22,
            column: 36
          }
        },
        loc: {
          start: {
            line: 22,
            column: 53
          },
          end: {
            line: 33,
            column: 3
          }
        },
        line: 22
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 30,
            column: 51
          },
          end: {
            line: 30,
            column: 52
          }
        },
        loc: {
          start: {
            line: 30,
            column: 57
          },
          end: {
            line: 32,
            column: 5
          }
        },
        line: 30
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 35,
            column: 23
          },
          end: {
            line: 35,
            column: 24
          }
        },
        loc: {
          start: {
            line: 35,
            column: 34
          },
          end: {
            line: 46,
            column: 3
          }
        },
        line: 35
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 35,
            column: 34
          },
          end: {
            line: 35,
            column: 35
          }
        },
        loc: {
          start: {
            line: 35,
            column: 40
          },
          end: {
            line: 46,
            column: 3
          }
        },
        line: 35
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 43,
            column: 51
          },
          end: {
            line: 43,
            column: 52
          }
        },
        loc: {
          start: {
            line: 43,
            column: 57
          },
          end: {
            line: 45,
            column: 5
          }
        },
        line: 43
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 48,
            column: 2
          },
          end: {
            line: 48,
            column: 3
          }
        },
        loc: {
          start: {
            line: 48,
            column: 11
          },
          end: {
            line: 83,
            column: 3
          }
        },
        line: 48
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 30,
            column: 30
          },
          end: {
            line: 30,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 30
          },
          end: {
            line: 30,
            column: 41
          }
        }, {
          start: {
            line: 30,
            column: 45
          },
          end: {
            line: 30,
            column: 47
          }
        }],
        line: 30
      },
      "1": {
        loc: {
          start: {
            line: 43,
            column: 30
          },
          end: {
            line: 43,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 43,
            column: 30
          },
          end: {
            line: 43,
            column: 41
          }
        }, {
          start: {
            line: 43,
            column: 45
          },
          end: {
            line: 43,
            column: 47
          }
        }],
        line: 43
      },
      "2": {
        loc: {
          start: {
            line: 63,
            column: 8
          },
          end: {
            line: 64,
            column: 10
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 63,
            column: 9
          },
          end: {
            line: 63,
            column: 41
          }
        }, {
          start: {
            line: 63,
            column: 45
          },
          end: {
            line: 63,
            column: 93
          }
        }, {
          start: {
            line: 64,
            column: 8
          },
          end: {
            line: 64,
            column: 10
          }
        }],
        line: 63
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e51146946f70cd6250cc56b46e570538ca5fb624"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1jpptz9cup = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1jpptz9cup();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * Component that displays a set of buttons (filters), so when clicking one of them a popup will show the filter content.
 * Once a filter is updated, this return the filter modified and new value to the parent component.
 */
var TabFilterBar = /*#__PURE__*/function (_PureComponent) {
  function TabFilterBar(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TabFilterBar);
    cov_1jpptz9cup().f[0]++;
    cov_1jpptz9cup().s[0]++;
    _this = _callSuper(this, TabFilterBar, [props]);
    (0, _defineProperty2.default)(_this, "mergeState", (cov_1jpptz9cup().s[2]++, function (partialState, callBack) {
      cov_1jpptz9cup().f[1]++;
      cov_1jpptz9cup().s[3]++;
      return _this.setState(function (prevState) {
        cov_1jpptz9cup().f[2]++;
        cov_1jpptz9cup().s[4]++;
        return (0, _assign.default)({}, prevState, partialState);
      }, callBack);
    }));
    (0, _defineProperty2.default)(_this, "handleFilterChanged", (cov_1jpptz9cup().s[5]++, function (tabCode) {
      cov_1jpptz9cup().f[3]++;
      cov_1jpptz9cup().s[6]++;
      return function (filterCriteria) {
        cov_1jpptz9cup().f[4]++;
        var filterByTab = (cov_1jpptz9cup().s[7]++, {
          filterByTab: _objectSpread(_objectSpread({}, _this.state.filter.filterByTab), {}, (0, _defineProperty2.default)({}, tabCode, filterCriteria))
        });
        cov_1jpptz9cup().s[8]++;
        _this.mergeState({
          filter: (cov_1jpptz9cup().b[0][0]++, filterByTab) || (cov_1jpptz9cup().b[0][1]++, {})
        }, function () {
          cov_1jpptz9cup().f[5]++;
          cov_1jpptz9cup().s[9]++;
          _this.props.onFilterApplied(filterByTab);
        });
      };
    }));
    (0, _defineProperty2.default)(_this, "handledFilterReset", (cov_1jpptz9cup().s[10]++, function (tabCode) {
      cov_1jpptz9cup().f[6]++;
      cov_1jpptz9cup().s[11]++;
      return function () {
        cov_1jpptz9cup().f[7]++;
        // Reset filterByTab of tabCode
        var filterByTab = (cov_1jpptz9cup().s[12]++, {
          filterByTab: _objectSpread(_objectSpread({}, _this.state.filter.filterByTab), {}, (0, _defineProperty2.default)({}, tabCode, _filter.DefaultFilterCriteria))
        });
        cov_1jpptz9cup().s[13]++;
        _this.mergeState({
          filter: (cov_1jpptz9cup().b[1][0]++, filterByTab) || (cov_1jpptz9cup().b[1][1]++, {})
        }, function () {
          cov_1jpptz9cup().f[8]++;
          cov_1jpptz9cup().s[14]++;
          _this.props.onFilterReset(tabCode);
        });
      };
    }));
    cov_1jpptz9cup().s[1]++;
    _this.state = {
      filter: props.filter
    };
    return _this;
  }
  (0, _inherits2.default)(TabFilterBar, _PureComponent);
  return (0, _createClass2.default)(TabFilterBar, [{
    key: "render",
    value: function render() {
      cov_1jpptz9cup().f[9]++;
      var _ref = (cov_1jpptz9cup().s[15]++, this.props),
        currencyCode = _ref.currencyCode,
        arrFilters = _ref.arrFilters,
        currentTabCode = _ref.currentTabCode,
        filter = _ref.filter,
        showPastDates = _ref.showPastDates,
        showToggle = _ref.showToggle;
      var _ref2 = (cov_1jpptz9cup().s[16]++, filter),
        filterByTab = _ref2.filterByTab;
      var filterCriteria = (cov_1jpptz9cup().s[17]++, filterByTab[currentTabCode]);
      var filterData = (cov_1jpptz9cup().s[18]++, {
        productTypesData: (cov_1jpptz9cup().b[2][0]++, filter.productTypesDataByTabCode) && (cov_1jpptz9cup().b[2][1]++, filter.productTypesDataByTabCode[currentTabCode]) || (cov_1jpptz9cup().b[2][2]++, [])
      });
      var customFilterForCurrentTab = (cov_1jpptz9cup().s[19]++, _objectSpread(_objectSpread({}, filter), filterData));
      cov_1jpptz9cup().s[20]++;
      return /*#__PURE__*/_react.default.createElement(_filterBar.default, {
        filter: customFilterForCurrentTab,
        onFilterChanged: this.handleFilterChanged(currentTabCode),
        onFilterReset: this.handledFilterReset(currentTabCode),
        currencyCode: currencyCode,
        arrFilters: arrFilters,
        filterCriteria: filterCriteria,
        showPastDates: showPastDates,
        showToggle: showToggle,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 72,
          columnNumber: 7
        }
      });
    }
  }]);
}(_react.PureComponent);
cov_1jpptz9cup().s[21]++;
TabFilterBar.propTypes = {
  /** Method to handler when the filter has been changed. It returns an object with the filter id and the new value */
  onFilterApplied: _propTypes.default.func.isRequired,
  /** Method to handler when the filter has been reset. */
  onFilterReset: _propTypes.default.func.isRequired,
  /** Filter already applied */
  filter: _propTypes.default.shape(_filter.FilterType),
  /** The needed currency to display prices */
  currencyCode: _propTypes.default.string.isRequired,
  /** True if we want to display past dates in the date filter  */
  showPastDates: _propTypes.default.bool,
  /** Current selected tab code */
  currentTabCode: _propTypes.default.string,
  /** The list of supported filters must be displayed */
  arrFilters: _propTypes.default.arrayOf(_propTypes.default.string),
  /** Show toggle */
  showToggle: _propTypes.default.bool
};
cov_1jpptz9cup().s[22]++;
TabFilterBar.defaultProps = {
  arrFilters: [_filter.FilterField.DATE, _filter.FilterField.PRICE],
  filter: {},
  currentTabCode: '',
  showPastDates: false,
  showToggle: false
};
var _default = exports.default = TabFilterBar;